<div class="fusionViewerContainer">
  <div id="fusionViewer" [style.height.px]="height"></div>
</div>
